export default __webpack_public_path__ + "static/media/Sycamore Icons-06.c9cce59c.svg";